function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Radio = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 26 26"
}, props), /*#__PURE__*/React.createElement("circle", {
  stroke: "#B9B9B9",
  opacity: "0.444",
  cx: "13",
  cy: "13",
  r: "8.5",
  fill: "none",
  strokeWidth: "2"
}), props.selected && /*#__PURE__*/React.createElement("polygon", {
  points: "13.2,14.8 8.9,10.7 7.5,12.1 13.2,17.5 25.5,5.9 24.1,4.5 ",
  fillRule: "nonzero",
  className: "checkMark"
}));

export default Radio;